const containsIsoDate = (str) => {
  // Regular expression for matching ISO 8601 date format (e.g., 2023-07-10 or 2023-07-10T10:00:00Z)
  const isoDateRegex = /\b\d{4}-\d{2}-\d{2}(?:T\d{2}:\d{2}(?::\d{2}(?:\.\d{1,3})?)?(?:Z|[+-]\d{2}:\d{2})?)?\b/;
  return isoDateRegex.test(str);
}

export const parseDatesArray = (datesArray) => {
  return datesArray.map((d) => {
    if (containsIsoDate(d)) {
      const parsedDate = new Date(d);
      const year = parsedDate.getFullYear();
      return year.toString();
    } else {
      return d;
    }
  });
}

const isNumberOrFloatString = (value) => {
  if (typeof value === "number" && !Number.isInteger(value)) {
    return true;
  }
  if (typeof value === "string") {
    // Regular expression to match a floating-point number
    const floatRegex = /^[+-]?\d+(\.\d+)?$/;
    return floatRegex.test(value);
  }
  return false;
}

export const formatFloat = (item) => {
  if (isNumberOrFloatString(item)) {
    return parseFloat(item).toFixed(2);
  }
  return item;
}

export const formatSeriesData = (seriesData) => {
  const seenNames = new Set();
  const processSeries = (data) => {
    if (!data || typeof data !== "object") return [];

    return Object.entries(data).flatMap(([key, value]) => {
      if (value?.name && Array.isArray(value?.data)) {
        if (!seenNames.has(value.name)) {
          seenNames.add(value.name);
          return [
            {
              name: value.name,
              data: value.data.map((item) =>
                typeof item === "number" && !Number.isInteger(item)
                  ? parseFloat(item.toFixed(2))
                  : item
              ),
            },
          ];
        }
      } else {
        return processSeries(value); // Recursive call for nested objects
      }
      return [];
    });
  }

  return processSeries(seriesData);
}

export const formatPieSeriesData = (seriesData,labels) => {
  let values = {}
  Object.values(seriesData).forEach((value) => {
    values[value.name] = value.data[0];
  })

  let data = [];
  labels.categories.forEach((label) => {
    if(label in values)
      data.push(values[label]);
  })

  return data;
}

export const capitalizeString = (str) => {
  if (typeof str !== "string" || str?.length === 0) {
    return "";
  }
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}